module.exports = __webpack_public_path__ + "img/logo_shoppingcna.ff5b7188.png";